import addDays from "date-fns/addDays";
import closestTo from "date-fns/closestTo";
import format from "date-fns/format";

export const closerToDate = (dates: string[]) => {
  if (!dates.length) return undefined;
  const dateToCompare = new Date();
  const result = closestTo(
    dateToCompare,
    dates.map((date) => new Date(date))
  );
  return result;
};

export const newDateWithoutTime = (date: Date = new Date()) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const getNextNDays = (n: number) => {
  const result = [];
  const today = new Date(); // Getting today's date
  for (let i = 1; i <= n; i++) {
    const nextDay = addDays(today, i); // Adding 'i' days to today's date
    result.push(format(nextDay, "yyyy-MM-dd")); // Formatting and pushing the date to the result array
  }
  return result;
};
